import React from 'react';
import styles from './Project.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faCode } from '@fortawesome/free-solid-svg-icons';
import defaultProjectImage from '../../assets/projectImg/default_ProjImg.png';

const Project = ({
    title,
    description,
    websiteLink,
    githubLinkFE,
    githubLinkBE,
    imageSrc,
    tags,
}) => {
    const displayImage = imageSrc || defaultProjectImage;

    return (
        <div className={styles.projectCard}>
            {/* Am mutat containerul de tag-uri deasupra titlului */}
            {tags && tags.length > 0 && (
                <div className={styles.tagsContainer}>
                    {tags.map((tag, index) => (
                        <span key={index} className={styles.tag}>
                            {tag}
                        </span>
                    ))}
                </div>
            )}
            <h3 className={styles.projectTitle}>{title}</h3>
            <div className={styles.imageContainer}>
                <img
                    src={displayImage}
                    alt={`Imagine descriptivă pentru proiectul ${title}`}
                    className={styles.projectImage}
                />
            </div>
            <p className={styles.projectDescription}>{description}</p>
            <div className={styles.projectLinks}>
                <div className={styles.websiteLinks}>
                    {websiteLink && (
                        <a
                            href={websiteLink}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.linkButton}
                        >
                            <FontAwesomeIcon
                                icon={faGlobe}
                                className={styles.buttonIcon}
                            />{' '}
                            Vizitează Website
                        </a>
                    )}
                </div>
                <div className={styles.linkCodeContainer}>
                    {githubLinkFE && (
                        <a
                            href={githubLinkFE}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.linkButton}
                        >
                            <FontAwesomeIcon
                                icon={faCode}
                                className={styles.buttonIcon}
                            />{' '}
                            FE
                        </a>
                    )}
                    {githubLinkBE && (
                        <a
                            href={githubLinkBE}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={styles.linkButton}
                        >
                            <FontAwesomeIcon
                                icon={faCode}
                                className={styles.buttonIcon}
                            />{' '}
                            BE
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Project;
